module.exports = __webpack_public_path__ + "img/center.7f11ca10.png";